import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent, Fragment } from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles"; //Limitless imports

import SubmitButton from "../../forms/submit-button/SubmitButton";

var ClosedMessageFooter = /*#__PURE__*/function (_PureComponent) {
  _inherits(ClosedMessageFooter, _PureComponent);

  var _super = _createSuper(ClosedMessageFooter);

  function ClosedMessageFooter() {
    _classCallCheck(this, ClosedMessageFooter);

    return _super.apply(this, arguments);
  }

  _createClass(ClosedMessageFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onButtonClick = _this$props.onButtonClick,
          classes = _this$props.classes;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classes.closedMessageContainer
      }, onButtonClick && /*#__PURE__*/React.createElement("div", {
        className: classes.newConversationButton
      }, /*#__PURE__*/React.createElement(SubmitButton, {
        disabled: false,
        id: "newConversationButton",
        title: "New Conversation",
        handleSubmit: onButtonClick,
        loading: false,
        containerEnabled: false,
        staticButton: true
      }))));
    }
  }]);

  return ClosedMessageFooter;
}(PureComponent);

var styles = {
  closedMessageContainer: {
    minHeight: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    height: "0px"
  },
  newConversationButton: {
    flex: "3 0 0",
    textAlign: "center"
  }
};
export default withStyles(styles)(ClosedMessageFooter);